import React from "react";
import {
  resetAllFilter,
  setLimit,
  setOrder,
  setTransactionType,
} from "../RTK/Features/filter/filterSlice";
import { useDispatch, useSelector } from "react-redux";

function AllTransactionsHeader() {
  const dispatch = useDispatch();
  let { searchTerm, transactionType, order, limit } = useSelector(
    (state) => state.filter
  );
  const [trnsactionPerPage, setTransactionPerPage] = React.useState(limit);

  const handleNoOfTrPerPage = (e) => {
    setTransactionPerPage(e.target.value);
    dispatch(setLimit(e.target.value));
  };
  const handleOrder = (order) => {
    dispatch(setOrder(order));
  };
  const handleClearFilter = () => {
    setTransactionPerPage(10);
    dispatch(resetAllFilter());
  };

  const { noOfTotalRecords } = useSelector((state) => state.transaction);
  return (
    <div className="w-full flex items-center justify-around p-4">
      <div className="flex gap-4">
        <div>
          <label className="text-slate-300" htmlFor="type">
            Type:
          </label>
        </div>
        <div className=" flex gap-12">
          <div>
            <input
              type="radio"
              id="all"
              name="type"
              checked={transactionType === ""}
              onChange={() => dispatch(setTransactionType(""))}
            />
            <label htmlFor="all" className="text-slate-300">
              All
            </label>
          </div>
          <div>
            <input
              type="radio"
              id="income"
              name="type"
              onChange={() => dispatch(setTransactionType("income"))}
              checked={transactionType === "income"}
            />
            <label htmlFor="income" className="text-slate-300">
              Income
            </label>
          </div>
          <div>
            <input
              type="radio"
              id="expense"
              name="type"
              checked={transactionType === "expense"}
              onChange={() => dispatch(setTransactionType("expense"))}
            />
            <label htmlFor="expense" className="text-slate-300">
              Expense
            </label>
          </div>
        </div>
      </div>

      <div className="flex gap-4">
        <label className=" text-slate-300">Order:</label>
        <select
          name="select"
          onChange={(event) => handleOrder(event.target.value)}
          className="w-[60px] bg-transparent  text-slate-300 border-[2px] border-slate-300 "
        >
          <option
            selected={order === ""}
            value={"desc"}
            className=" text-slate-900 "
          >
            Descending
          </option>
          <option value={"asc"} className=" text-slate-900">
            Ascending
          </option>
        </select>
      </div>

      <div className="flex gap-4">
        <label className=" text-slate-300">Transaction Per Page:</label>
        <select
          name="select"
          value={trnsactionPerPage}
          onChange={(event) => handleNoOfTrPerPage(event)}
          className="w-[60px] bg-transparent  text-slate-300 border-[2px] border-slate-300 "
        >
          <option value={2} className=" text-slate-900 ">
            2
          </option>
          <option value={6} className=" text-slate-900">
            6
          </option>
          <option value={10} className=" text-slate-900">
            10
          </option>
          <option value={20} className=" text-slate-900">
            20
          </option>
          <option value={noOfTotalRecords} className=" text-slate-900">
            All
          </option>
        </select>
      </div>
      <div className="flex gap-4">
        {(searchTerm || transactionType || order || limit !== 10) && (
          <div
            className="bg-red-500  text-slate-300 p-2 cursor-pointer hover:bg-red-700"
            onClick={handleClearFilter}
          >
            Clear Filter
          </div>
        )}
      </div>
    </div>
  );
}

export default AllTransactionsHeader;
